import React, { Component } from 'react';
import { Link } from "react-router-dom";
import _ from "lodash";
import HsForm from 'react-hubspot-form'
import Header from "./Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MetaTags from 'react-meta-tags';
import track from "../lib/tracking";

class HubspotForm extends Component {


  render() {

    return (
      <div className="form">
        <MetaTags>
          <title>Film Release Update, Euro Film Launches</title>
          <meta name="description" content="Fill in this form to let us know if we need to update any information about the release of your movie." />
          <meta property="og:title" content="Film Release Update, Euro Film Launches" />
        </MetaTags>
        <div className="contact-form">
          <Link className="header__back" to="/">
            <FontAwesomeIcon icon="chevron-left" />
            <div>Back</div>
          </Link>
          <div className="contact-form__title"><FontAwesomeIcon icon="exclamation-triangle" /><h3>Film Release Update Form</h3></div>
          <HsForm
            portalId='3477242'
            formId="420dd393-d0be-4ad6-9ef1-77dc50349864"
            onSubmit={() => track("hubspot_form_submitted",{})}
            onReady={(form) => console.log('Form ready!')}
            loading={<div>Loading...</div>}
          />
        </div>
      </div>
    );
  }

}

export default HubspotForm;



// WEBPACK FOOTER //
// ./src/components/HubspotForm.js